module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn__copy",
    attrs: {
      "data-clipboard-text": _vm.text
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))]), _vm._v(" "), _c('span', {
    staticClass: "txt-active"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.copied')) + "!")])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a32b7656!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/CopyButton.vue
 ** module id = 894
 ** module chunks = 1
 **/